import { motion } from "framer-motion";
import { COMPANY, STORY, MD_MESSAGE, VALUES } from "@/components/laneeka/data";
import { IMAGES } from "@/components/site/data";

export default function AboutPage() {
  return (
    <main data-testid="about-page" className="pt-[108px]">
      <section className="bg-slate-50 border-b border-slate-200 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-blue-700 mb-3">About</p>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Who we are</h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <h2 className="text-2xl font-bold tracking-tight text-slate-900 mb-5">Our story</h2>
            <div className="space-y-4 text-slate-600 leading-relaxed">
              {STORY.map((p, i) => (
                <p key={i} data-testid={`story-para-${i}`}>{p}</p>
              ))}
              <p>
                Equally, our company values the wellbeing and professional growth of our employees. We foster a
                culture of mutual respect and continuous development, ensuring that everyone in our organization
                feels supported and empowered to achieve their best.
              </p>
            </div>
            <div className="mt-8 flex flex-wrap gap-2" data-testid="values-chips">
              {VALUES.map((v) => (
                <span key={v} className="text-xs font-semibold bg-slate-100 text-slate-700 px-3 py-1.5 rounded-full">{v}</span>
              ))}
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }}>
            <img src={IMAGES.steelAssembly} alt="Laneeka International facility" className="w-full rounded-xl border border-slate-200 object-cover aspect-[4/3]" />
          </motion.div>
        </div>
      </section>

      <section className="py-16 bg-slate-50 border-t border-slate-200" data-testid="md-message">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-[220px_1fr] gap-8 items-center">
          <img
            src="/team/founder-full.png"
            alt={MD_MESSAGE.name}
            className="w-48 h-60 object-cover rounded-xl border border-slate-200 bg-slate-200 mx-auto"
            data-testid="md-photo"
          />
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-blue-700 mb-6">Message from the Managing Director</p>
            <blockquote className="text-lg sm:text-xl font-medium text-slate-900 leading-relaxed">
              "{MD_MESSAGE.quote}"
            </blockquote>
            <p className="mt-6 text-sm text-slate-600">
              <span className="font-semibold text-slate-900">{MD_MESSAGE.name}</span> — {MD_MESSAGE.role}, {COMPANY.name}
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
